import * as React from 'react'
import * as Redux from 'react-redux'
import { createPortal } from 'react-dom'

import * as commonLayout from '@owl-nest/layout'
import * as layout from '@ulule/layout'
import * as shadow from '@owl-nest/shadow'
import { useAuth } from '@owl-nest/redux-wrapper/hooks'
import { TaxDeductionModal } from '@owl-nest/tip'

import * as modalAction from '../../actions/modal'
import * as modalReducer from '../../reducers/modals/followModal'
import * as modalSubmitReducer from '../../reducers/modals/submitModal'
import * as projectModel from '../models/project'
import { type RootState } from '../../reducers'

import { LaunchShareModal } from '../views/detail/components/LaunchShareModal'
import { PaymentDisturbanceModal } from '../views/detail/components/PaymentDisturbanceModal'
import { RewardModals } from '../views/detail/components/RewardModals'
import { TRACKING_SOURCE } from '../views/detail/utils/trackerEnums'

import { SubmitModal } from '../components/LilSam/view/Submit/index'

type PublicLayoutProps = {
  children: React.ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps): React.ReactElement<PublicLayoutProps> {
  const dispatch = Redux.useDispatch()
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const auth = useAuth()
  const userIsAuthenticated = auth.type === 'loggedin'

  const modalFollow = Redux.useSelector<RootState, modalReducer.State>((state) => state.application.followModal)
  const modalSubmit = Redux.useSelector<RootState, modalSubmitReducer.State>((state) => state.application.submitModal)

  const modalContainerCached = React.useMemo(() => document.getElementById('modal-container') ?? document.body, [])

  return (
    <>
      {children}

      {createPortal(<RewardModals />, modalContainerCached)}

      {createPortal(<PaymentDisturbanceModal />, modalContainerCached)}

      {createPortal(
        <commonLayout.FollowProjectModal
          isOpen={modalFollow.open}
          onClose={() => {
            if (modalFollow.shouldReloadPage) {
              window.location.reload()
            }
            dispatch(modalAction.toggleModalFollow(false))
          }}
          userIsAuthenticated={userIsAuthenticated}
          project={project}
        />,
        modalContainerCached,
      )}

      {createPortal(
        <SubmitModal
          open={modalSubmit.open}
          onClose={modalSubmit.handleClose}
          onSubmit={modalSubmit.handleSubmit}
          project={project}
        />,
        modalContainerCached,
      )}

      {createPortal(<LaunchShareModal project={project} />, modalContainerCached)}
      {createPortal(
        <layout.modals.ShareProject
          project={project}
          trackingConfig={{
            category: shadow.CATEGORY.PROJECT_PAGE,
            source: TRACKING_SOURCE.HERO,
          }}
        />,
        modalContainerCached,
      )}

      <TaxDeductionModal project={project} />
    </>
  )
}
